module.exports = __webpack_public_path__ + "static/key-funwithragdolls-a82bb6c75b6ed719a87376b3e0ec10e4.webp";